import { render } from "./UploadData.vue?vue&type=template&id=374cb4c0&scoped=true"
import script from "./UploadData.vue?vue&type=script&lang=js"
export * from "./UploadData.vue?vue&type=script&lang=js"

import "./UploadData.vue?vue&type=style&index=0&id=374cb4c0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-374cb4c0"]])

export default __exports__